import { makeStyles } from '@material-ui/core';
import DoubleArrowIcon from '@material-ui/icons/DoubleArrow';
import i18n from 'i18n';
import React from 'react';
import styles from './styles';

const useStyles = makeStyles(styles);

interface AdvisorImpactProps {
  impact?: string;
}

const AdvisorImpact = ({ impact }: AdvisorImpactProps) => {
  const classes = useStyles();

  const impactMap: Record<string, { icon: JSX.Element; label: string }> = {
    low: {
      icon: <DoubleArrowIcon className={classes.lowImpact} />,
      label: i18n.t('LOW_IMPACT_KEY'),
    },
    medium: {
      icon: <DoubleArrowIcon className={classes.mediumImpact} />,
      label: i18n.t('MEDIUM_IMPACT_KEY'),
    },
    high: {
      icon: <DoubleArrowIcon className={classes.highImpact} />,
      label: i18n.t('HIGH_IMPACT_KEY'),
    },
  };

  const data = impactMap[impact ?? ''];

  return data ? (
    <span className={classes.impactGrid}>
      {data.icon}
      {data.label}
    </span>
  ) : (
    <>{impact}</>
  );
};

export default AdvisorImpact;
